/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/indent */
import React, { FC, useState, ReactElement } from 'react'
import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom'
import { Formik } from 'formik'
import { Form, Alert } from 'react-bootstrap'
import * as yup from 'yup'
import API from '@aws-amplify/api'
import { observer, inject } from 'mobx-react'
import { makeStyles } from '@material-ui/core/styles'
import {
  ListItemText,
  ListItemIcon,
  List,
  ListItem,
  Collapse,
  Divider,
  TextField,
} from '@material-ui/core'
import moment from 'moment'
import { FaRegCircle, FaCheckCircle } from 'react-icons/fa'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { MultiSelect } from 'react-multi-select-component'
import Layout from '../../components/Dashboard/newLayout'
import LoadingButton from '../../components/LoadingButton'
import { assignManeuverList } from '../../components/Dashboard/Contacts'
import { industriesPrefill } from '../../utils/constants'
import { Prospects as ProspectsStore } from '../../stores/prospects'
import './styles.scss'
import { Search as SearchStore } from '../../stores/search'

const schema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  company: yup.string().required('Company is required'),
  emailAddress: yup
    .string()
    .email('Must be a valid email')
    .required('Email is required'),
  phone: yup.string(),
  companyUrl: yup.string(),
  linkedinUrl: yup.string(),
  twitterUrl: yup.string(),
  instagramUrl: yup.string(),
  facebookUrl: yup.string(),
  firstTouch: yup.bool(),
})

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nestedSecondLevel: {
    paddingLeft: theme.spacing(6),
  },
  nestedThirdLevel: {
    paddingLeft: theme.spacing(8),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}))

interface Props extends RouteComponentProps {
  emailUser: string
  setIsAuthenticated: (isAuthenticated: boolean) => void
  prospects?: ProspectsStore
  search?: SearchStore
}

const AddSingleContact: FC<Props> = (props: any) => {
  const { emailAddress = '', emailUser, setIsAuthenticated, prospects, search } = props
  const [isLoading, setIsLoading] = useState(false)
  const [hot, setHot] = useState('')
  const [maneuverType, setManeuverType] = useState('')
  const [openAssignManeuver, setOpenAssignManeuver] = useState('')
  const [openAssignMission, setOpenAssignMission] = useState('')
  const [openAssignEmail, setOpenAssignEmail] = useState('')
  const [industryType, setIndustryType] = useState([])
  const classes = useStyles()
  const history = useHistory()

  const onChangeHot = (type: string): void => {
    if (hot === type) {
      setHot('')
      return
    }
    setHot(type)
  }

  const onChangeManeuver = (type: string): void => {
    if (maneuverType === type) {
      setManeuverType('')
      return
    }
    setManeuverType(type)
  }

  const handleClickAssignManeuver = (value): void => {
    if (openAssignManeuver === value) {
      setOpenAssignManeuver('')
    } else {
      setOpenAssignManeuver(value)
    }
    setOpenAssignMission('')
    setOpenAssignEmail('')
  }

  const handleClickAssignMission = (value): void => {
    if (openAssignMission === value) {
      setOpenAssignMission('')
    } else {
      setOpenAssignMission(value)
    }
    setOpenAssignEmail('')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClickAssignEmail = (value): void => {
    if (openAssignEmail === value) {
      setOpenAssignEmail('')
    } else {
      setOpenAssignEmail(value)
    }
  }

  const handleManeuverChange = (event): void => {
    console.log(event.target.value, moment(new Date(), 'YYYY-MM-DD'))
  }
  const addToMaverick = async (values: {
    firstName: string
    lastName: string
    title: string
    company: string
    emailAddress: string
    phone: string
    companyUrl: string
    linkedinUrl: string
    twitterUrl: string
    instagramUrl: string
    facebookUrl: string
    addedBy: string
    industry: string
    firstTouch: boolean
  }): Promise<void> => {
    setIsLoading(true)

    const payload = {
      name: `${values.firstName} ${values.lastName}`,
      firstName: values.firstName,
      lastName: values.lastName,
      title: values.title,
      company: values.company,
      emailAddress: values.emailAddress,
      phoneNumber: values.phone,
      companyUrl: values.companyUrl,
      linkedinUrl: values.linkedinUrl,
      twitterUrl: values.twitterUrl,
      instagramUrl: values.instagramUrl,
      facebookUrl: values.facebookUrl,
      industry: industryType.map((item: any) => item.value),
      owner: emailUser,
      domain: values.emailAddress.substring(values.emailAddress.lastIndexOf('@') + 1),
      maneuver: '',
      mission: '',
      maverickStatus: '',
      isHot: hot === 'Affirmative',
    }
    if (openAssignMission !== '') {
      let assignManeuver = 'First Touch'
      if (openAssignManeuver === 'Engaged') assignManeuver = 'Follow Up'
      else if (openAssignManeuver === 'Re-Engage') assignManeuver = 'Nurture'
      payload.maneuver = assignManeuver
      payload.mission = openAssignMission
      payload.maverickStatus = 'Activated'
    }

    const myInit = { body: payload }
    try {
      await API.post('mav-outlook-api', `/leads/${values.emailAddress}`, myInit)
      setIsLoading(false)
      prospects?.setCacheValid(true)
      search.addSingleLeadToTable(payload)
      history.push(`/${values.emailAddress}`)
    } catch (e) {
      console.error(e)
      setIsLoading(false)
    }
  }
  const industryOptions = industriesPrefill?.map(industry => ({ label: industry, value: industry }))
  return (
    <Layout title="Add Single Contact" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="contact-body">
          <Formik
            validationSchema={schema}
            onSubmit={addToMaverick}
            initialValues={{
              firstName: '',
              lastName: '',
              title: '',
              company: '',
              emailAddress,
              phone: '',
              companyUrl: '',
              linkedinUrl: '',
              twitterUrl: '',
              instagramUrl: '',
              facebookUrl: '',
              addedBy: '',
              industry: '',
              firstTouch: false,
            }}
          >
            {({
              handleSubmit,
              values,
              handleChange,
              touched,
              errors,
              submitCount,
            }): ReactElement => (
              <Form noValidate onSubmit={handleSubmit} className="form">
                <Form.Row>
                  <Form.Group className="mb-3">
                    <Form.Group controlId="firstName">
                      <Form.Row>
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          autoFocus
                          required
                          value={values.firstName}
                          onChange={handleChange}
                          isValid={touched.firstName && !errors.firstName}
                          isInvalid={submitCount > 0 && !!errors.firstName}
                          placeholder="ex: Charlotte"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.firstName}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="lastName">
                      <Form.Row>
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.lastName}
                          onChange={handleChange}
                          isValid={touched.lastName && !errors.lastName}
                          isInvalid={submitCount > 0 && !!errors.lastName}
                          placeholder="ex: Backwood"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.lastName}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="title">
                      <Form.Row>
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.title}
                          onChange={handleChange}
                          isValid={touched.title && !errors.title}
                          isInvalid={submitCount > 0 && !!errors.title}
                          placeholder="ex: In-flight Trainer"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.title}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="company">
                      <Form.Row>
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.company}
                          onChange={handleChange}
                          isValid={touched.company && !errors.company}
                          isInvalid={submitCount > 0 && !!errors.company}
                          placeholder="ex: Stars Aviation Consulting"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.company}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="industry">
                      <Form.Row>
                        <Form.Label>Industry</Form.Label>
                        <MultiSelect
                          overrideStrings={{ selectSomeItems: 'Industries...' }}
                          options={industryOptions}
                          value={industryType}
                          onChange={setIndustryType}
                          labelledBy="Industries..."
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.industry}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="emailAddress">
                      <Form.Row>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          disabled={Boolean(emailAddress)}
                          value={values.emailAddress}
                          onChange={handleChange}
                          isValid={touched.emailAddress && !errors.emailAddress}
                          isInvalid={submitCount > 0 && !!errors.emailAddress}
                          placeholder="ex: charlie@websitename.com"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.emailAddress}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="phone">
                      <Form.Row>
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.phone}
                          onChange={handleChange}
                          isValid={touched.phone && !errors.phone}
                          isInvalid={submitCount > 0 && !!errors.phone}
                          placeholder="ex: 123-123-1234"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.phone}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="companyUrl">
                      <Form.Row>
                        <Form.Label>Company URL</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.companyUrl}
                          onChange={handleChange}
                          isValid={touched.companyUrl && !errors.companyUrl}
                          isInvalid={submitCount > 0 && !!errors.companyUrl}
                          placeholder="ex: websitename.com"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.companyUrl}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="linkedinUrl">
                      <Form.Row>
                        <Form.Label>Linkedin URL</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.linkedinUrl}
                          onChange={handleChange}
                          isValid={touched.linkedinUrl && !errors.linkedinUrl}
                          isInvalid={submitCount > 0 && !!errors.linkedinUrl}
                          placeholder="ex: linkedin.com/charlotteblackwood"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.linkedinUrl}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="twitterUrl">
                      <Form.Row>
                        <Form.Label>Twitter URL</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.twitterUrl}
                          onChange={handleChange}
                          isValid={touched.twitterUrl && !errors.twitterUrl}
                          isInvalid={submitCount > 0 && !!errors.twitterUrl}
                          placeholder="ex: twitter.com/charliefliesbetter"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.twitterUrl}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="instagramUrl">
                      <Form.Row>
                        <Form.Label>Instagram URL</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.instagramUrl}
                          onChange={handleChange}
                          isValid={touched.instagramUrl && !errors.instagramUrl}
                          isInvalid={submitCount > 0 && !!errors.instagramUrl}
                          placeholder="ex: instagram.com/charliefliesbetter"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.instagramUrl}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="facebookUrl">
                      <Form.Row>
                        <Form.Label>Facebook URL</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={values.facebookUrl}
                          onChange={handleChange}
                          isValid={touched.facebookUrl && !errors.facebookUrl}
                          isInvalid={submitCount > 0 && !!errors.facebookUrl}
                          placeholder="ex: facebook.com/charliefliesbetter"
                        />
                        <Form.Control.Feedback type="invalid">
                          <Alert variant="danger">{errors.facebookUrl}</Alert>
                        </Form.Control.Feedback>
                      </Form.Row>
                    </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Group controlId="hot">
                      <Form.Row>
                        <Form.Label>Hot</Form.Label>
                        <div className="flex-column">
                          <Divider />
                          <div className="hot">
                            <ListItem
                              button
                              className={classes.nested}
                              onClick={(): void => onChangeHot('Affirmative')}
                            >
                              <ListItemIcon>
                                {hot === 'Affirmative' ? (
                                  <FaCheckCircle className="check_icon" />
                                ) : (
                                  <FaRegCircle />
                                )}
                              </ListItemIcon>
                              <ListItemText primary="Affirmative" />
                            </ListItem>
                            <ListItem
                              button
                              className={classes.nested}
                              onClick={(): void => onChangeHot('Negative')}
                            >
                              <ListItemIcon>
                                {hot === 'Negative' ? (
                                  <FaCheckCircle className="check_icon" />
                                ) : (
                                  <FaRegCircle />
                                )}
                              </ListItemIcon>
                              <ListItemText primary="Negative" />
                            </ListItem>
                            <Divider />
                          </div>
                          <Divider />
                        </div>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="mission">
                      <Form.Row>
                        <Form.Label>Assign to Maneuver</Form.Label>
                        <div className="flex-column">
                          <Divider />
                          <div className="hot">
                            <ListItem
                              button
                              className={classes.nested}
                              onClick={(): void => onChangeManeuver('Affirmative')}
                            >
                              <ListItemIcon>
                                {maneuverType === 'Affirmative' ? (
                                  <FaCheckCircle className="check_icon" />
                                ) : (
                                  <FaRegCircle />
                                )}
                              </ListItemIcon>
                              <ListItemText primary="Affirmative" />
                            </ListItem>
                            <ListItem
                              button
                              className={classes.nested}
                              onClick={(): void => onChangeManeuver('Negative')}
                            >
                              <ListItemIcon>
                                {maneuverType === 'Negative' ? (
                                  <FaCheckCircle className="check_icon" />
                                ) : (
                                  <FaRegCircle />
                                )}
                              </ListItemIcon>
                              <ListItemText primary="Negative" />
                            </ListItem>
                            <Divider />
                          </div>
                          <Divider />
                        </div>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="mission">
                      <Form.Row className="float-end">
                        <Collapse in={maneuverType === 'Affirmative'} timeout="auto" unmountOnExit>
                          {assignManeuverList.map(maneuver => (
                            <List component="div" disablePadding key={`${maneuver.name}`}>
                              <ListItem
                                button
                                className={classes.nested}
                                onClick={(): void => handleClickAssignManeuver(maneuver.name)}
                              >
                                <ListItemIcon>
                                  {openAssignManeuver === maneuver.name ? (
                                    <FaCheckCircle className="check_icon" />
                                  ) : (
                                    <FaRegCircle />
                                  )}
                                </ListItemIcon>
                                <ListItemText primary={maneuver.name} />
                                {openAssignManeuver === maneuver.name ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </ListItem>
                              <Collapse
                                in={openAssignManeuver === maneuver.name}
                                timeout="auto"
                                unmountOnExit
                              >
                                {maneuver.missions.map(mission => (
                                  <List
                                    component="div"
                                    disablePadding
                                    key={`${maneuver.name}-${mission.name}`}
                                  >
                                    <ListItem
                                      button
                                      className={classes.nestedSecondLevel}
                                      onClick={(): void => handleClickAssignMission(mission.name)}
                                    >
                                      <ListItemIcon>
                                        {openAssignManeuver === maneuver.name &&
                                        openAssignMission === mission.name ? (
                                          <FaCheckCircle className="check_icon" />
                                        ) : (
                                          <FaRegCircle />
                                        )}
                                      </ListItemIcon>
                                      <ListItemText primary={mission.name} />
                                    </ListItem>
                                  </List>
                                ))}
                              </Collapse>
                            </List>
                          ))}
                        </Collapse>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group
                      controlId="hot"
                      style={{ display: maneuverType === 'Affirmative' ? 'block' : 'none' }}
                    >
                      <Form.Row>
                        <Form.Label>Launch Date</Form.Label>
                        <div className="flex-column">
                          <Divider />
                          <div className="hot">
                            <TextField
                              id="datetime-local"
                              label="Start Date"
                              type="date"
                              defaultValue={moment(new Date()).format('YYYY-MM-DD')}
                              className={classes.textField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                min: new Date().toISOString().split('T')[0],
                              }}
                              onChange={handleManeuverChange}
                            />
                            <Divider />
                          </div>
                          <Divider />
                        </div>
                      </Form.Row>
                    </Form.Group>
                    <Form.Group controlId="actions">
                      <Form.Row>
                        <LoadingButton variant="primary" block isLoading={isLoading} type="submit">
                          Add Contact to MaverickApp
                        </LoadingButton>
                      </Form.Row>
                    </Form.Group>
                  </Form.Group>
                </Form.Row>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Layout>
  )
}

export default inject('prospects', 'search')(withRouter(observer(AddSingleContact)))
